export default __webpack_public_path__ + "static/media/reservation.046944c2.svg";